import { render, staticRenderFns } from "./TabelaCadastros.vue?vue&type=template&id=b5d28fae&scoped=true"
import script from "./TabelaCadastros.vue?vue&type=script&lang=js"
export * from "./TabelaCadastros.vue?vue&type=script&lang=js"
import style0 from "./TabelaCadastros.vue?vue&type=style&index=0&id=b5d28fae&prod&lang=css"
import style1 from "./TabelaCadastros.vue?vue&type=style&index=1&id=b5d28fae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d28fae",
  null
  
)

export default component.exports